import CardApplicationScreen from 'features/believe/application/CardApplicationScreen/CardApplication';
import React from 'react';

export default function CardApplicationPage() {
  return <CardApplicationScreen />;
}
